<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Район</label>
              <Select2
                class="select2"
                :options="districtList"
                v-model="currFilters.districtId"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Контекстный поиск (Фамилия, Имя, Отчество)"
                placeholder="Введите ФИО"
                v-model="currFilters.FIO"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="СНИЛС"
                placeholder="XXX-XXX-XXX YY"
                mod-class="snils"
                type="snils"
                v-model="currFilters.snils"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Дата рождения</label>
              <div class="patient-date__range" style="display: flex">
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.dateOfBirthFrom"
                />
                <div class="mx-2 my-1">-</div>
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.dateOfBirthTo"
                  :class-name="{ 'input-error': v$.currFilters.dateOfBirthTo.$invalid }"
                />
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Возраст"
                placeholder="Введите возраст"
                v-model="currFilters.age"
                type="int"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Регистровый номер"
                placeholder="Введите регистровый номер"
                v-model="currFilters.registerNumber"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Пол</label>
              <Select2
                placeholder="Все"
                class="select2"
                :options="maleOptions"
                v-model="currFilters.male"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Тип документа</label>
              <Select2
                class="select2"
                :options="docTypeList"
                v-model="currFilters.docType"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Серия/номер документа"
                placeholder="Серия/номер документа"
                v-model="currFilters.docSerieNum"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Дата внесения в Регистр</label>
              <div class="patient-date__range" style="display: flex">
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.createdFrom"
                />
                <div class="mx-2 my-1">-</div>
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.createdTo"
                  :class-name="{ 'input-error': v$.currFilters.createdTo.$invalid }"
                />
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Организация, добавившая в Регистр</label>
              <Select2
                class="select2"
                placeholder="Не выбрано"
                :options="organizationList"
                v-model="currFilters.createdByOrgId"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <h4>Диагностика</h4>
          <div class="col-12">
            <div class="form-group">
              <div class="patient-date__range" style="display: flex">
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.diagnosticDateFrom"
                />
                <div class="mx-2 my-1">-</div>
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.diagnosticDateTo"
                  :class-name="{ 'input-error': v$.currFilters.diagnosticDateTo.$invalid }"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <h4>Медицинский полис</h4>
          <div class="col-12">
            <div class="form-group">
              <label>Тип полиса</label>
              <Select2
                class="select2"
                placeholder="Не выбрано"
                :options="insuranceTypeList"
                v-model="currFilters.insType"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Серия/номер полиса"
                placeholder="Серия/номер полиса"
                v-model="currFilters.insSerieNum"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="currFilters.isWaitDiagnostic"
                id="chWaitDignostik"
              />
              <label for="chWaitDignostik" class="form-check-label"
                >Ожидает диагностику</label
              >
            </div>
          </div>
          <div class="col-12">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="currFilters.agree"
                id="chAgree"
              />
              <label for="chAgree" class="form-check-label"
                >Cогласие на включение в регистр РАС</label
              >
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <h4>Данные представителя</h4>
          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                v-model="currFilters.represFIO"
                placeholder="Введите ФИО"
                label="Контекстный поиск (Фамилия, Имя, Отчество)"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                v-model="currFilters.represSnils"
                placeholder="XXX-XXX-XXX YY"
                type="snils"
                label="СНИЛС"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                v-model="currFilters.represDocSerieNum"
                placeholder="Серия/номер паспорта"
                label="Серия/номер паспорта"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Исключен из реестра:</label>
              <select class="form-control" v-model="currFilters.isDeleted">
                <option v-for="item in yesNoList" :value="item.id">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-12" v-if="canViewDeletedPermanently">
            <div class="form-group">
              <label>Архивные записи:</label>
              <select class="form-control" v-model="currFilters.isDeletedPermanently">
                <option v-for="item in yesNoList" :value="item.id">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Выход из концепции:</label>
              <select class="form-control" v-model="currFilters.exitFromConcept">
                <option v-for="item in yesNoList" :value="item.id">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Статус взаимодействия</label>
              <Select2 :options="statusList" v-model="currFilters.statusId" />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer justify-content-between border-0 bg-white d-flex">
        <button-component class="col-6" @click="apply">
          Применить
        </button-component>
        <button-component class="col-6" kind="secondary" @click="reset">
          Сбросить
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import DateComponent from "@/common/components/DateComponent";
import ButtonComponent from "@/common/ui/ButtonComponent";
import Utils from "@/common/utils";
import ComponentInput from "@/common/components/ComponentInput";
import Constants from "@/common/constants";
import rasApi from "../api/ras";
import security from "@/common/mixins/security";
import { useVuelidate } from "@vuelidate/core";

export default {
  name: "PatientsFilters",
  components: { ComponentInput, ButtonComponent, DateComponent },
  mixins: [security],
  props: {
    filters: Object,
  },
  data() {
    return {
      maleOptions: [
        { id: 1, text: "Все", selected: true },
        { id: true, text: "Мужской", value: true },
        { id: false, text: "Женский", value: false },
      ],
      insuranceTypeList: [
        {
          id: 0,
          text: Constants.emptySelectOptionText,
          selected: false,
        },
      ],
      organizationList: [
        {
          id: 0,
          text: Constants.emptySelectOptionText,
          selected: false,
        },
      ],
      docTypeList: [
        {
          id: 3,
          text: Constants.emptySelectOptionText,
          selected: true,
        },
        {
          text: "Паспорт РФ",
          id: 0,
          selected: false,
        },
        {
          text: "Свидетельство о рождении",
          id: 1,
          selected: false,
        },
      ],
      statusList: [
        {
          id: 0,
          text: Constants.emptySelectOptionText,
          selected: false,
        },
      ],
      yesNoList: Constants.yesNoList,
      districtList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      currFilters: this.filters,
      canViewDeletedPermanently: false
    };
  },
  methods: {
    apply() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire(
          "Ошибка",
          "Проверьте правильность заполнения фильтров",
          "error"
        );
        return;
      }

      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        FIO: "",
        docSerieNum: "",
        docType: 2,
        snils: "",
        isWaitDiagnostic: null,
        agree: null,
        socialStatus: null,
        insType: 0,
        insSerieNum: "",
        represFIO: "",
        respesSnils: "",
        represDocSerieNum: "",
        isDeleted: false,
        isDeletedPermanently: false,
        registerNumber: "",
        dateOfBirthFrom: null,
        dateOfBirthTo: null,
        createdFrom: null,
        createdTo: null,
        createdByOrgId: 0,
        diagnosticDateFrom: null,
        diagnosticDateTo: null,
        statusId: 0,
        age: null,
        districtId: 0,
        male: null,
        exitFromConcept: null
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
  created() {
    this.checkPermission(Constants.PatientDeletePermanentlyView).then((response) => {
      this.canViewDeletedPermanently = response.data;
      if(!this.canViewDeletedPermanently)
        this.isDeletedPermanently = false;
    });

    Utils.loadSelectOptions("district", this.districtList, {
      regionId: Constants.regionNizhnyNovgorodId,
    });
    Utils.loadSelectOptions("insuranceType", this.insuranceTypeList);
    Utils.loadSelectOptions("patientStatusList", this.statusList);
    rasApi.loadCreatedOrg().then(
      (response) => {
        this.organizationList = response.data;
        this.organizationList.unshift({
          id: 0,
          text: Constants.emptySelectOptionText,
          selected: true,
        });
      }
    );
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      currFilters: {
        diagnosticDateTo: { notBeforeFrom: (value) => {
          if (!value) return true;
          if (!this.currFilters.diagnosticDateFrom) return true;
          return new Date(value) >= new Date(this.currFilters.diagnosticDateFrom);
        } },
        dateOfBirthTo: { notBeforeFrom: (value) => {
          if (!value) return true;
          if (!this.currFilters.dateOfBirthFrom) return true;
          return new Date(value) >= new Date(this.currFilters.dateOfBirthFrom);
        } },
        createdTo: { notBeforeFrom: (value) => {
          if (!value) return true;
          if (!this.currFilters.createdFrom) return true;
          return new Date(value) >= new Date(this.currFilters.createdFrom);
        } },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";

.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}
h4 {
  font-size: 16px;
}
.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.select2::v-deep {
  .select2-container {
    width: 100%;
  }

  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
  }

  .select2-container--default
    .select2-selection--single
    .select2-selection__arrow {
    top: 7px !important;
  }
}
</style>
